export default __webpack_public_path__ + "static/media/99.8cd18516.gif";